// extracted by mini-css-extract-plugin
export default {"container":"ZkedCH","icon":"BIdoOj","return":"P2ZweA","section":"Lc5pOv","date":"kfPAET"};